export class UsuarioCNPJ{
    usuarioCNPJID: number;
    cnpj: string;
    usuarioID: number;
    novo: boolean;
}